import React from 'react';
import { useStateValue } from './AppContext.jsx';
import {makeBreedString, makeAgeString, makePhotoUrl} from './AnimalFunctions.jsx';

function Animal(props) {
  const [ {uploadBase}, dispatch ] = useStateValue();

  //include both primary and secondary breeds if set
  let breed = makeBreedString(props);
  let age = makeAgeString(props);
  let photoUrl = makePhotoUrl(uploadBase, props.photos);

  return (
    <div
      className="animal"
      id={props.id}
      onClick={(event) => {
        dispatch({
          type: 'makeActiveAnimal',
          animal: props
        })
      }}
      >
      <aside
        className="animal_image"
        style={{backgroundImage: `url(${photoUrl})`}}
        >
      </aside>
      <p className="animal_name name notranslate">{props.name}</p>
      <p className="animal_name id notranslate">{props.animal_id}</p>
      <div className="animal_info">
        <div className="animal_info_row flex">
          <div className="animal-info-title">Sex:</div>
          <div className="animal-info-value notranslate">{props.sex}</div>
        </div>
        <div className="animal_info_row flex">
          <div className="animal-info-title">Age:</div>
          <div className="animal-info-value notranslate">{age} (approx)</div>
        </div>
        <div className="animal_info_row flex">
          <div className="animal-info-title">Location:</div>
          <div className="animal-info-value notranslate">{props.location}</div>
        </div>
        <div className="animal_info_row flex lost_found_location">
          <div className="animal-info-title">Lost/Found Location:</div>
          <div className="animal-info-value notranslate">{props.lf_city}</div>
        </div>
      </div>
    </div>
  );
}

export default Animal;
